import React from 'react';
import './Styles/Container.scss';
import StyledButton from '../../Shared/StyledButton/StyledButton';
import { benefits, days, hours, jobs, process, related, requirements, responsibilities, salary } from './data';
import {List} from '../Prototyping/Container';
import Section from '../Monzo/Section';
import icon1 from '../../../Assets/Icons/Facebook.svg';
import icon2 from '../../../Assets/Icons/twitter1.svg';
import icon3 from '../../../Assets/Icons/youtube.svg';
import icon4 from '../../../Assets/Icons/twitter2.svg';

const Container=()=>{
    return(
        <div className="front-container">
            <div className="btn-part">

            <StyledButton btn="Apply Now" />
            </div>
            <div className="data">
                <List title="Responsibilities:"
                list={responsibilities}
                />
                <List title="Requirements:"
                list={requirements}
                />
                <Section 
                title="Educational Requirements"
                desc="It doesn’t matter where you went to college or what your CGPA was as long as you are smart, passionate, ready to work hard, and have fun"
                />
                <List 
                title="Working Hours :"
                list = {hours}
                />
                <List 
                title="Working Days :"
                list={days}
                />
                <List 
                title="Salary"
                list={salary}
                />
                <List 
                title="🧡 Benefits You’ll Get 🧡"
                list={benefits}
                />
                <List 
                title="The Application Process"
                list={process}
                />
                <Section 
                title="Our Statement"
                desc="HostDesign is committed to creating the happiest company working for and is proud to provide equal opportunity to all. All the qualified applicants will receive consideration for employment without regard to race, color, ancestry, religion, sex,  sexual orientation, age, citizenship, marital status, disability, gender identity, or any other basis protected by federal, state, or local law.
                "
                />
                <Section 
                desc="Application Deadline: July 26, 2021"
                />
                <StyledButton btn="Apply Now" />
            </div>
            <div className="right">
                <div className="job">
                    <h2>Job Summary</h2>
                    <ul>
                        {jobs.map((item) =>{
                            return(
                                <li>
                                    <div>
                                        <img src={item.icon} />
                                    </div>
                                    <div>
                                        <h2>{item.title}</h2>
                                        <p>{item.desc}</p>
                                    </div>
                                </li>
                            )
                        })}
                    </ul>
                </div>
                <div className="socials">
                    <h2>Share This</h2>
                    <ul>
                        <li><img src={icon1} /></li>
                        <li><img src={icon2} /></li>
                        <li><img src={icon3} /></li>
                        <li><img src={icon4} /></li>

                    </ul>
                </div>
                <div className="related">
                    <h2>Related Job</h2>
                    <ul>
                        {related.map((item) =>{
                            return(
                                <li>
                                    <h3>{item.title}</h3>
                                    <p>{item.desc}</p>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>
        </div>
    )
};
export default Container ;